/* __next_internal_client_entry_do_not_use__ chunkTransformations,NoTranslate,StrictLocalMsg auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { StrictBaseLocalMsg } from "@faire/web--source/common/localization";
import React from "react";
import { chunkTransformations } from "./common";
export { chunkTransformations, NoTranslate } from "./common";
/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/component/strict-local-message)
 */ export var StrictLocalMsg = function(_param) {
    var values = _param.values, props = _object_without_properties(_param, [
        "values"
    ]);
    // Only merge if there's actually something special given, to reduce computation.
    var valuesAndTransforms = Object.keys(values !== null && values !== void 0 ? values : {}).length ? _object_spread({}, chunkTransformations, values) : chunkTransformations;
    return /*#__PURE__*/ _jsx(StrictBaseLocalMsg, _object_spread_props(_object_spread({}, props), {
        values: valuesAndTransforms
    }));
};
